// frontend/src/components/dashboard/IndicadorCard.jsx
import React from 'react';

/* =======================
   PALETA — AURORA CLEAN
======================= */
const AURORA = {
  emerald: '#34D399',
  purple: '#A78BFA',
  amber: '#F59E0B',
  border: 'rgba(255,255,255,0.08)',
  text: 'rgba(255,255,255,0.95)',
  text2: 'rgba(255,255,255,0.65)',
  text3: 'rgba(255,255,255,0.45)',
};

const TONES = {
  success: AURORA.emerald,
  info: AURORA.purple,
  brand: AURORA.purple,
  warning: AURORA.amber,
  neutral: 'rgba(255,255,255,0.5)',
};

function formatValue(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return '0';
  return new Intl.NumberFormat('pt-BR').format(n);
}

/**
 * ✅ NOVO PADRÃO ELION (Minimal Premium)
 *
 * Props:
 * - title
 * - total
 * - monthValue
 * - delta (ex: +2, -1)
 * - tone
 */
export default function IndicadorCard({
  title,
  icon: Icon,
  tone = 'neutral',
  loading = false,
  compact = true,
  total = 0,
  monthValue = null,
  delta = null,
  hint,
  onClick,
}) {
  const interactive = typeof onClick === 'function';
  const Root = interactive ? 'button' : 'div';

  const accent = TONES[tone] || TONES.neutral;

  if (loading) {
    return (
      <div
        className="h-[82px] animate-pulse rounded-2xl border bg-white/5 backdrop-blur"
        style={{ borderColor: AURORA.border }}
      />
    );
  }

  return (
    <Root
      type={interactive ? 'button' : undefined}
      onClick={interactive ? onClick : undefined}
      className={[
        'relative w-full rounded-2xl border bg-white/5 backdrop-blur text-left transition-all',
        'hover:-translate-y-0.5 hover:shadow-xl',
        compact ? 'px-4 py-3' : 'px-5 py-4',
        interactive ? 'cursor-pointer' : '',
      ].join(' ')}
      style={{ borderColor: AURORA.border }}
      title={hint || undefined}
    >
      {/* Top Accent Line */}
      <div
        className="absolute top-0 left-0 right-0 h-[2px] rounded-t-2xl"
        style={{
          background: `linear-gradient(90deg, ${accent}, transparent)`,
        }}
      />

      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          {/* Título */}
          <div
            className="text-[11px] uppercase tracking-[0.12em] truncate"
            style={{ color: AURORA.text2 }}
          >
            {title}
          </div>

          {/* Valor Principal */}
          <div
            className="mt-1 text-[24px] font-extrabold leading-none"
            style={{ color: AURORA.text }}
          >
            {formatValue(total)}
          </div>

          {/* Linha inferior limpa */}
          {(monthValue !== null || delta !== null) && (
            <div
              className="mt-1 text-[11px] flex items-center gap-2"
              style={{ color: AURORA.text3 }}
            >
              {monthValue !== null && (
                <span>Este mês: {formatValue(monthValue)}</span>
              )}

              {delta !== null && (
                <span
                  className={`font-semibold ${
                    delta > 0
                      ? 'text-emerald-400'
                      : delta < 0
                        ? 'text-red-400'
                        : ''
                  }`}
                >
                  {delta > 0 ? `+${delta}` : delta}
                </span>
              )}
            </div>
          )}
        </div>

        {/* Ícone minimal */}
        {Icon && (
          <div
            className="grid place-items-center rounded-xl border"
            style={{
              borderColor: AURORA.border,
              height: 36,
              width: 36,
            }}
          >
            <Icon size={16} strokeWidth={2} style={{ color: accent }} />
          </div>
        )}
      </div>
    </Root>
  );
}
